import { useNotify, useRedirect } from "ra-core";

import LayoutContainer from "../components/LayoutContainer";
import { Box, Grid } from "@material-ui/core";

import StatusInput from "../components/StatusInput";
import LeftGridEdit from "../components/LeftGridEdit";
import RightGridEdit from "../components/RightGridEdit";
import TextInputRA from "../components/TextInputRA";
import CategoryValidation from "../../../ValidationRules/CategoryValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
import { Loading } from "ra-ui-materialui";
const CategoryEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Category",
    write: true,
  });
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  if (loading) return <Loading />;
  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          onSuccess={onSuccess}
          onFailure={onFailure}
          {...props}
          validate={CategoryValidation}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Categories/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA
              placeholder="Category name"
              required
              label="Category name"
              source="name"
            />
            <TextInputRA
              placeholder="Description"
              label="Description"
              source="desc"
            />
            <StatusInput />
          </Box>
        </LeftGridEdit>
        <RightGridEdit {...props} noImage />
      </Grid>
      {/* <Edit
        mutationMode="pessimistic"
        onSuccess={onSuccess}
        onFailure={onFailure}
        {...props}
      >
        <SimpleForm>
          <TextInputRA label="Product name" source="name" />
          <TextInputRA label="Description" source="desc" />
        </SimpleForm>
      </Edit> */}
    </LayoutContainer>
  );
};

export default CategoryEdit;
